// src/config/env.js
export const Env = {
  supabaseUrl: 'https://reescgwvnnbvwgtadvdv.supabase.co',
  supabaseAnonKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJlZXNjZ3d2bm5idndndGFkdmR2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjMzODYwOTUsImV4cCI6MjA3ODk2MjA5NX0.kU6E7PW9pxC0uf1DGD266uLoLfYtYZUYrSnhOxPBb5Q',

  // Chargily Keys
  chargilyApiKey: 'live_sk_xbgLCigdhRleqtDaIZLhTERMOixU1NyDL1ujH5dT', // المفتاح من الكود الذي أرفقته

  // Backblaze B2
  backblazeKeyId: '005eb6889bd2d450000000001',
  backblazeAppKey: 'K005fsrfzsR3eVMH7wgrUmfE8RN25tY',
  backblazeBucketId: '9e3b76d808a9dbfd92cd0415',
  backblazeBucketName: 'khidma-digital-products',

  // Cloudflare Worker
  cloudflareWorkerUrl: 'https://red-hill-9d90.mouhoubifares12.workers.dev',
  cloudflareSecretToken: 'khidma_secret_2026_xyz',

  // CCP (Compte Courrier Postal) — حساب الدفع للديون
  ccpAccountNumber: '92051234567801234',
};
